import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import FloatingPasswordValidator from '../FloatingPasswordValidator/FloatingPasswordValidator';
import { TextBox } from 'components/form/TextBox/index';

const HelpPasswordValidatorCmp = props => {
  const {
    password,
    passwordFocused,
    passwordError,
    showPreviousPasswordWarning,
  } = props;
  return (
    <FloatingPasswordValidator
      password={password}
      passwordFocused={passwordFocused}
      submitError={passwordError}
      showPreviousPasswordWarning={showPreviousPasswordWarning}
      {...props}
    />
  );
};

export const PasswordValidationField = props => {
  const {
    datatestid,
    password,
    passwordError,
    onChange,
    onFocus,
    onBlur,
    placeholder,
    positionRelative,
  } = props;
  const _placeholder = placeholder ? placeholder : 'Enter Password';
  return (
    <FlexContainer className="flex-column">
      {!positionRelative && <HelpPasswordValidatorCmp {...props} />}
      <TextBox
        type="password"
        datatestid={`${datatestid}-password`}
        name="password"
        value={password}
        error={passwordError}
        onChange={onChange}
        placeholder={_placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        outerClassName={'passwordValidation'}
        fullWidth
      />
      {positionRelative && <HelpPasswordValidatorCmp {...props} />}
    </FlexContainer>
  );
};
